<div class="container-fluid">
    @if(configInitial) {
        <img [src]="configInitial.loader.src" [height]="350" alt="Cargando...">
    }@else {
        <div class="loader"></div> 
    }
</div>